import axios from "../config";

export const postLogin = (body: any) => {
  return axios.post("/login", body);
};
